module.exports = __webpack_public_path__ + "img/fabulous7.7cbf005a.svg";